module.exports = __webpack_public_path__ + "media/images/emblems/Ardon-blazono-19c8605bf7efe3c850f11ead9b65ef72.png";